import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import '../../assets/css/styles.css'
import Config from '../../commons/config/Config.js';
import ConfigBusiness from '../../commons/config/ConfigBusiness.js'
import FormValidation from '../../commons/validation/FormValidation.js'
import Validator from '../../commons/validation/Validator.js'
import Loading from '../ui/Loading.js'
import swal from 'sweetalert'
import {FormattedMessage, injectIntl} from 'react-intl';
import backendStrings from '../../lang/backendStrings.js';
import Notificacion from '../app/Notificacion.js';

const FALLBACK_MESSAGES = {
    'login.errors.invalido': { id: 'login.errors.invalido', defaultMessage: 'Usuario o contraseña incorrectos.' },
    'login.errors.activar_cuenta': { id: 'login.errors.activar_cuenta', defaultMessage: 'Su usuario se encuentra inactivo. Contacte al administrador.' },
    'login.errors.No_se_encontro_numero_de_telefono_asociado_a_su_usuario': { id: 'login.errors.no_phone', defaultMessage: 'No se encontró celular asociado para 2FA.' },
    'authService.errors.contrasenia_debe_tener_una_longitud_entre': { id: 'auth.pass.len', defaultMessage: 'La contraseña debe tener entre 8 y 16 caracteres.' },
    'errors.internal_server_error': { id: 'error.500', defaultMessage: 'Error interno del servidor.' }
};

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            formData: { usuario: null, clave: null },
            errors:[], loading: false, redirectTo: null,
            loginEnabled : ConfigBusiness.get("frontend.loginInstancia.habilitado"),
            mantenimientoEnabled: ConfigBusiness.get("frontend.mantenimiento.habilitado"),
            mantenimientoMensaje: (ConfigBusiness.get("frontend.mantenimiento.mensaje") || props.intl.formatMessage({id: 'login.mantenimiento.mensaje_default', defaultMessage: "Estamos realizando mejoras en el sistema.\nVolveremos a estar operativos a la brevedad."})).split('\n'),
            mantenimientoFechaFin: ConfigBusiness.get("frontend.mantenimiento.fechaFin"),
            mantenimientoCountdown: null, loginServices: {},
            azureLoginRedirect: Config.get('apiUrlBase') + '/public/auth/azure/redirect',
            googleLoginRedirect: Config.get('apiUrlBase') + '/public/auth/google/redirect',
            loadingLogoLogin: true, logoLoginUrl: null, languages:[],
            languagesExtra: { "es": "Español", "en": "Inglés" },
            showVersionFull: false, configError: false, retryCountdown: 60,
            isLegacyDomain: false, countdown: 10, focusUser: false, focusPass: false
        }
        this.handleFormChange = this.handleFormChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleForgotPassword = this.handleForgotPassword.bind(this);
        this.loginRandom = null;
        this.changeLocale = this.changeLocale.bind(this);
        this.maintenanceInterval = null; this.statusCheckInterval = null; this.retryInterval = null; this.redirectInterval = null;
    }

    getBrandedLogo(defaultFilename, visibilityConfigKey = null) {
        if (visibilityConfigKey) {
            const isVisible = ConfigBusiness.get(visibilityConfigKey);
            if (isVisible === "false") return null;
        }
        const clientSlug = ConfigBusiness.get("generales.clienteSlug");
        if (clientSlug && clientSlug !== "false" && clientSlug !== "default") {
            return `${process.env.PUBLIC_URL}/images/branding/${clientSlug}/${defaultFilename}`;
        }
        return `${process.env.PUBLIC_URL}/images/company/${defaultFilename}`;
    }

    updateCountdown = () => {
        if (!this.state.mantenimientoFechaFin) return;
        const distancia = new Date(this.state.mantenimientoFechaFin).getTime() - new Date().getTime();
        if (distancia < 0) {
            this.setState({ mantenimientoCountdown: this.props.intl.formatMessage({id: 'login.mantenimiento.finalizando', defaultMessage: "Finalizando tareas..."}) });
            return;
        }
        const horas = Math.floor((distancia % (86400000)) / 3600000);
        const minutos = Math.floor((distancia % 3600000) / 60000);
        const segundos = Math.floor((distancia % 60000) / 1000);
        this.setState({ mantenimientoCountdown: `${horas}h ${minutos}m ${segundos}s` });
    }

    checkMaintenanceStatus = () => {
        const timestamp = new Date().getTime();
        const checkUrl = Config.get('apiUrlBase') + '/public/auth/services?t=' + timestamp;
        fetch(checkUrl, { method: 'GET' }).then(res => {
            if(res.status === 200) {
               res.json().then(data => {
                   if(this.state.mantenimientoFechaFin && new Date() > new Date(this.state.mantenimientoFechaFin)){
                       window.location.reload();
                   }
               });
            }
        }).catch(err => {});
    }

    startRetryCountdown = () => {
        if(this.retryInterval) clearInterval(this.retryInterval);
        this.setState({ retryCountdown: 60 });
        this.retryInterval = setInterval(() => {
            this.setState((prevState) => {
                if (prevState.retryCountdown <= 1) {
                    clearInterval(this.retryInterval);
                    window.location.reload();
                    return { retryCountdown: 0 };
                }
                return { retryCountdown: prevState.retryCountdown - 1 };
            });
        }, 1000);
    }

    componentWillMount () {
        this.formValidation = new FormValidation({
            component: this,
            validators: {
                'formData.usuario': (value) => Validator.notEmpty(value),
                'formData.clave': (value) => Validator.notEmpty(value)
            }
        });
        const customAppLogo = ConfigBusiness.get("frontend.logos.app");
        if (customAppLogo && customAppLogo !== "true" && customAppLogo !== "false") {
             this.setState({ logoLoginUrl: process.env.PUBLIC_URL + "/images/company/" + customAppLogo, loadingLogoLogin: false });
        } else {
            fetch(Config.get('apiUrlBase') + '/public/contextos_imagenes/logoLogin', {
                method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
            }).then(response => {
                let contentType = response.headers.get('Content-Type');
                if (contentType && contentType.startsWith('image/')) return response.blob();
                throw new Error('No es imagen');
            }).then(blob => {
                this.setState({ logoLoginUrl: URL.createObjectURL(blob) });
            }).catch(() => {}).finally(() => {
                this.setState({ loadingLogoLogin: false });
            });
        }
    }

    componentDidMount () {
        document.body.className = 'vertical-layout vertical-menu 1-column menu-expanded blank-page blank-page';
        document.body.setAttribute('data-col', '1-column');
        const hostname = window.location.hostname;
        const isOldProd = (hostname === 'telecom.vec.com.ar' || hostname === 'telecom.vecfleet.io');
        const isOldTest = (hostname === 'testing-teco.vec.com.ar');

        if (this.state.mantenimientoEnabled === "true") {
            if (this.state.mantenimientoFechaFin) {
                this.updateCountdown();
                this.maintenanceInterval = setInterval(this.updateCountdown, 1000);
            }
            this.statusCheckInterval = setInterval(this.checkMaintenanceStatus, 30000);
        }

        if (isOldProd || isOldTest) {
            const target = isOldProd ? 'https://personal.vecfleet.io' : 'https://personal-test.vecfleet.io';
            this.setState({ isLegacyDomain: true, targetUrl: target });
            this.redirectInterval = setInterval(() => {
                this.setState((prevState) => {
                    if (prevState.countdown <= 1) {
                        clearInterval(this.redirectInterval);
                        window.location.replace(target);
                        return { countdown: 0 };
                    }
                    return { countdown: prevState.countdown - 1 };
                });
            }, 1000);
        }

        fetch(Config.get('apiUrlBase') + '/public/auth/services', {
            method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        }).then(response => {
            if(response.status === 200) {
                response.json().then(data => { this.setState({ loginServices: data }) });
            } else {
                this.setState({ configError: true });
                this.startRetryCountdown();
            }
        }).catch(() => {
            this.setState({ configError: true });
            this.startRetryCountdown();
        }).finally(() => {
            this.setState({ loading: false });
            if (this.state.loginServices && (this.state.loginServices.classic === 'true' || this.state.loginServices.classic === true) && this.state.mantenimientoEnabled !== "true") {
                if(this.refs.usuario) this.refs.usuario.focus();
            }
        });

        let lang = ConfigBusiness.get("frontend.multilenguaje");
        try {
            const langJson = JSON.parse(lang);
            if (langJson) {
                this.setState({ languages: langJson.map(elem => { elem.title = this.state.languagesExtra[elem.lang]; return elem; }) });
            }
        } catch(e) {}
    }

    componentWillUnmount() {
        if (this.redirectInterval) clearInterval(this.redirectInterval);
        if (this.maintenanceInterval) clearInterval(this.maintenanceInterval);
        if (this.statusCheckInterval) clearInterval(this.statusCheckInterval);
        if (this.retryInterval) clearInterval(this.retryInterval);
    }

    handleFormChange(event) {
        const target = event.target;
        let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
        formDataCopy[target.name] = target.value;
        this.setState({ formData: formDataCopy, errors:[] }); // Limpiar error al tipear
    }

    handleSubmit(event) {
        this.setState({ loading: true, errors:[] });
        fetch(Config.get('apiUrlBase') + '/public/auth/login', {
            method: 'POST', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({ ...this.state.formData }),
        }).then(response => {
            if(response.status === 200) {
                response.json().then(data => {
                    if(data && data.usuario && data.usuario.token) {
                        localStorage.setItem('persona', JSON.stringify(data));
                        localStorage.setItem('token', data.usuario.token);
                        localStorage.setItem('cerrarNotificacion', false);
                        if (data.usuario.enable_twofa && ConfigBusiness.get("2fa.habilitado") == "true") {
                            if(!data.celularCodArea || !data.celularNumero){
                                swal({ title: "Atención", text: "No se encontró celular para 2FA.", icon: "error" });
                            }else{
                                this.setState({ redirectTo: '/auth/2fa' })
                            }
                        } else { window.location.reload(); }
                    } else { this.error(); }
                });
            } else if(response.status === 401) {
                response.json().then(data => {
                    let msgs = data.detalle ||['login.errors.invalido'];
                    this.setState({ errors: msgs });
                }).catch(() => { this.setState({ errors: ['login.errors.invalido'] }); });
            } else if(response.status === 400 || response.status === 403) {
                response.json().then(data => {
                    const msgKey = (data.detalle && data.detalle[0]) ? data.detalle[0] : 'errors.default';
                    this.setState({ errors:[msgKey] }); // Lo mostramos in-line, sin swal que rompe flow
                });
            } else { this.error(); }
        }).catch(() => { this.error("Problema de conexión con el servidor."); })
        .finally(() => { this.setState({ loading: false }); });
        event.preventDefault();
    }

    handleForgotPassword(e) { this.setState({ redirectTo: '/olvide-clave' }); e.preventDefault(); }
    changeLocale(locale) { localStorage.setItem('userLocale', locale); window.location.reload(); }

    error(customMsg = null) {
        swal({ title: "Error", text: customMsg || "Contacte al administrador.", icon: "error" });
    }

    render() {
        this.formValidation.validate();
        let validationState = this.formValidation.state;
        if(!this.loginRandom) this.loginRandom = 1 + Math.floor((4 - 1) * Math.random());

        const logoAppSrc = this.state.logoLoginUrl || this.getBrandedLogo("logo-login-app.png");
        const logoCompanySrc = this.getBrandedLogo("logo-login-company.png", "frontend.logos.company.visible");
        const logoPoweredBySrc = this.getBrandedLogo("logo-login-powered-by.png", "frontend.logos.poweredBy.visible");
        const versionLabel = process.env.REACT_APP_VERSION || "0.0.0";
        const shortVersion = versionLabel.split('-')[0];
        const isVersionLong = versionLabel.length > 10;
        const dateText = new Date() > new Date('2026-01-08T00:00:00') ? "Plataforma obsoleta." : "Operativa hasta 08/01/2026.";

        return (
            <React.Fragment>
                {ConfigBusiness.get("generales.alertaSuspension")==='true' && (
                    <Notificacion closeable={false} title="Aviso" message="Tu cuenta tiene un pago pendiente." top="0" />
                )}
                {this.state.redirectTo && <Redirect push to={this.state.redirectTo} />}
                {this.state.loading && <Loading hideSpinner />}
                
                <div className="app-content content">
                    <div className="content-wrapper">
                        <div className="content-body">
                            <video className="video-login-bg" autoPlay muted loop poster={process.env.PUBLIC_URL + "/images/images-login/image"+ this.loginRandom +".png"}>
                                <source src={process.env.PUBLIC_URL + "/images/videos-login/video"+ this.loginRandom +".mp4"} type="video/mp4"/>
                            </video>
                            
                            <section className="flexbox-container">
                                <div className="col-12 d-flex align-items-center justify-content-center">
                                    <div className="col-11 col-sm-8 col-md-6 col-lg-4 p-0" style={{maxWidth: '380px'}}>
                                        <div className="card border-0 m-0" style={{borderRadius: '1rem', boxShadow: '0 15px 35px rgba(0,0,0,0.2)'}}>
                                            
                                            {/* Logo más compacto (mb-0 pb-0) */}
                                            <div id="loginLogo" className="card-header border-0 text-center pb-0" style={{paddingTop: '1.5rem'}}>
                                                {!this.state.loadingLogoLogin && 
                                                    <img src={logoAppSrc} alt="App Logo" className="img-fluid center-block" style={{ maxHeight: '90px', objectFit: 'contain' }} onError={(e) => { e.target.onerror = null; e.target.src = process.env.PUBLIC_URL + "/images/company/logo-login-app.png"; }}/>
                                                }
                                            </div>
                                            
                                            <div className="card-body" style={{padding: '1rem 1.5rem 1.5rem'}}>
                                                {this.state.configError ? (
                                                    <div className="text-center py-1">
                                                        <div className="mb-1"><i className="la la-exclamation-triangle" style={{ fontSize: '40px', color: '#dc3545' }}></i></div>
                                                        <h5 className="text-danger font-weight-bold">Problemas de Conexión</h5>
                                                        <small className="text-muted">Reintentando en {this.state.retryCountdown}s...</small>
                                                        <button className="btn btn-outline-danger btn-block btn-sm mt-2" onClick={() => window.location.reload()} style={{borderRadius: '8px'}}>Reintentar Ahora</button>
                                                    </div>
                                                ) : this.state.mantenimientoEnabled === "true" ? (
                                                    <div className="text-center py-1">
                                                        <div className="mb-1"><i className="la la-cog spinner text-warning" style={{ fontSize: '40px' }}></i></div>
                                                        <h5 className="font-weight-bold">Mantenimiento</h5>
                                                        {this.state.mantenimientoCountdown && <span className="badge badge-secondary p-1 mt-1">{this.state.mantenimientoCountdown}</span>}
                                                    </div>
                                                ) : (
                                                    <React.Fragment>
                                                        {this.state.isLegacyDomain ? (
                                                            <div className="text-center py-1">
                                                                <h5 className="font-weight-bold">¡Nos estamos mudando!</h5>
                                                                <small>Redirigiendo en {this.state.countdown}s...</small>
                                                                <button className="btn btn-success btn-sm btn-block mt-2" style={{borderRadius: '8px'}} onClick={() => window.location.href = this.state.targetUrl}>Ir al nuevo sitio</button>
                                                            </div>
                                                        ) : (
                                                            <div className="login-normal-flow mt-1">
                                                                {this.state.loginEnabled === "false" ? (
                                                                    <div className="text-center py-2"><h5 className="text-muted">Plataforma no disponible.</h5></div>
                                                                ) : (
                                                                    <React.Fragment>
                                                                        {(this.state.loginServices.classic === 'true' || this.state.loginServices.classic === true) &&
                                                                            <form className="form-horizontal" noValidate ref="form" onSubmit={this.handleSubmit}>
                                                                                <fieldset className="form-group position-relative has-icon-left mb-1">
                                                                                    <input type="text" className="form-control" style={{borderRadius: '8px', transition: 'border-color 0.2s', borderColor: this.state.focusUser ? '#0056b3' : '#d9d9d9', paddingLeft:'35px', height:'42px'}} id="usuario" name="usuario" ref="usuario" placeholder={this.props.intl.formatMessage({ id: 'login.usuario.placeholder', defaultMessage: 'Usuario' })} tabIndex="1" required="" onChange={this.handleFormChange} onFocus={() => this.setState({focusUser: true})} onBlur={() => this.setState({focusUser: false})} />
                                                                                    <div className="form-control-position" style={{top:'1px'}}><i className="la la-user" style={{color: this.state.focusUser ? '#0056b3' : '#a1a1a1'}}></i></div>
                                                                                </fieldset>

                                                                                <fieldset className="form-group position-relative has-icon-left mb-1">
                                                                                    <input type="password" className="form-control" style={{borderRadius: '8px', transition: 'border-color 0.2s', borderColor: this.state.focusPass ? '#0056b3' : '#d9d9d9', paddingLeft:'35px', height:'42px'}} id="clave" name="clave" placeholder={this.props.intl.formatMessage({ id: 'login.contraseña.placeholder', defaultMessage: 'Contraseña' })} tabIndex="2" required onChange={this.handleFormChange} onFocus={() => this.setState({focusPass: true})} onBlur={() => this.setState({focusPass: false})} />
                                                                                    <div className="form-control-position" style={{top:'1px'}}><i className="la la-key" style={{color: this.state.focusPass ? '#0056b3' : '#a1a1a1'}}></i></div>
                                                                                </fieldset>
                                                                                
                                                                                {/* FIX DEVOPS: Error sutil sin fondo que empuje todo */}
                                                                                <div className="text-center mb-1" hidden={this.state.errors.length===0} style={{minHeight:'18px'}}>
                                                                                    <small className="text-danger font-weight-bold">
                                                                                        {this.state.errors.map((e, i) => {
                                                                                            let msg = backendStrings[e] || FALLBACK_MESSAGES[e] || { id: 'error.generic', defaultMessage: e };
                                                                                            return <span key={i}><FormattedMessage {...msg}/> </span>
                                                                                        })}
                                                                                    </small>
                                                                                </div>

                                                                                <div className="form-group row mb-1 mt-0">
                                                                                    <div className="col-12 text-right">
                                                                                        <button type="button" className="btn btn-link p-0 text-muted" style={{fontSize: '12px', textDecoration: 'none'}} onClick={e => this.handleForgotPassword(e)}>
                                                                                            <i className="ft-unlock"></i> ¿Olvidó su contraseña?
                                                                                        </button>
                                                                                    </div>
                                                                                </div>
                                                                                
                                                                                <button type="submit" className="btn btn-primary btn-block shadow-sm" style={{borderRadius: '8px', height:'42px', fontWeight: '500'}} disabled={!validationState.form.valid}>
                                                                                    <i className={this.state.loading ? 'la la-spinner spinner' : 'la la-sign-in mr-1'}></i> Ingresar
                                                                                </button>
                                                                            </form>
                                                                        }
                                                                        {(this.state.loginServices.google === 'true' || this.state.loginServices.google === true) && 
                                                                            <div className="mt-1"><a href={this.state.googleLoginRedirect} className="btn btn-outline-secondary btn-block bg-white shadow-sm d-flex align-items-center justify-content-center" style={{borderRadius: '8px', height: '42px', color: '#555', textDecoration:'none'}}><img style={{width: '18px', marginRight: '8px'}} src={process.env.PUBLIC_URL + "/images/google.svg"} alt="G"/><span className="font-weight-bold" style={{fontSize: '13px'}}>Ingresar con Google</span></a></div>
                                                                        }
                                                                        {(this.state.loginServices.azure === 'true' || this.state.loginServices.azure === true) && 
                                                                            <div className="mt-1"><a href={this.state.azureLoginRedirect} className="btn btn-outline-secondary btn-block bg-white shadow-sm d-flex align-items-center justify-content-center" style={{borderRadius: '8px', height: '42px', color: '#555', textDecoration:'none'}}><img style={{width: '18px', marginRight: '8px'}} src={process.env.PUBLIC_URL + "/images/microsoft.svg"} alt="MS"/><span className="font-weight-bold" style={{fontSize: '13px'}}>Ingresar con Microsoft</span></a></div>
                                                                        }
                                                                    </React.Fragment>
                                                                )}
                                                            </div>
                                                        )}
                                                    </React.Fragment>
                                                )}

                                                <div className="mt-3 pt-2" style={{borderTop: '1px solid #f3f3f3'}}>
                                                    <div className="row align-items-center">
                                                        <div className="col-6 text-left">
                                                            {logoCompanySrc && <img src={logoCompanySrc} alt="Company" className="img-fluid" style={{maxHeight: '35px', maxWidth: '100%', objectFit:'contain'}} onError={(e) => { e.target.onerror = null; e.target.src = process.env.PUBLIC_URL + "/images/company/logo-login-company.png"; }} />}
                                                        </div>
                                                        <div className="col-6 text-right">
                                                            {logoPoweredBySrc && <img src={logoPoweredBySrc} alt="Powered By" className="img-fluid" style={{maxHeight: '30px', maxWidth: '100%', objectFit:'contain'}} onError={(e) => { e.target.onerror = null; e.target.src = process.env.PUBLIC_URL + "/images/company/logo-login-powered-by.png"; }} />}
                                                        </div>
                                                    </div>
                                                    <div className="text-center mt-2 d-flex justify-content-between align-items-center px-1">
                                                        <div className="d-flex">
                                                            {this.state.languages.map((elem,index) => (
                                                                <span key={index} onClick={() => this.changeLocale(elem.lang)} className="cursor-pointer mx-1" title={elem.title}>
                                                                    <img className="flag-multilang" src={process.env.PUBLIC_URL + "/images/flags/" + elem.code + ".svg"} alt={elem.code} style={{width: '28px'}}/>
                                                                </span>
                                                            ))}
                                                        </div>
                                                        <div className="version-info" style={{ cursor: 'pointer' }} onClick={() => this.setState({ showVersionFull: !this.state.showVersionFull })}>
                                                            <span style={{ display: 'inline-block', fontWeight: '500', fontSize: '10px', padding: '3px 8px', color: '#6c757d', backgroundColor: '#fff', border: '1px solid #e0e0e0', borderRadius: '20px' }}>
                                                                v{this.state.showVersionFull ? versionLabel : shortVersion} {isVersionLong && (this.state.showVersionFull ? '▲' : '▼')}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* ESCOBITA */}
                                                <div style={{ position: 'absolute', top: '15px', right: '15px', zIndex: 100, opacity: 0.5, cursor: 'pointer' }}>
                                                    <a href="/salir" title="Limpiar Caché" style={{textDecoration: 'none'}}><i className="la la-broom" style={{ fontSize: '22px', color: '#666' }}></i></a>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}
export default injectIntl(Login);
